import { actions } from "./types";

export function updateFiguritas(figuritas) {
  return (dispatch) => {
    dispatch({
      type: actions.UPDATE_FIGURITAS,
      payload: figuritas,
    });
  };
}

export function setAlbumsAutorizados(objects) {
  return (dispatch) => {
    dispatch({
      type: actions.ALBUMS_AUTORIZADOS,
      payload: objects,
    });
  };
}

export function setMiAlbum(objects) {
  return (dispatch) => {
    dispatch({
      type: actions.MI_ALBUM,
      payload: objects,
    });
  };
}
